import { debounce } from 'lodash';
import { compose, lifecycle, mapProps, withProps } from 'recompose';
import moment from 'moment/moment';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';

import { Endpoints } from '../../../lib/LeanLinkService';
import * as holidaySelectors from '../../../entities/Holiday/selectors';
import { withFetch } from '../../../entities/Entity/containers';

export default compose(
  withFetch({
    props: props => ({
      ...props,
      fetchHolidays: debounce(() => {
        const endpoint = props.public ? Endpoints.public.resourceApi.holidays : Endpoints.holidays;
        const sortedDates = props.dates.sort();
        const firstDate = sortedDates.first();
        const lastDate = sortedDates.last();
        props.fetch({
          url: endpoint({
            limit: 1000,
            filters: {
              from: moment(firstDate).format('YYYY-MM-DD'),
              to: moment(lastDate).format('YYYY-MM-DD'),
            },
          }),
        });
      }, 2000),
    }),
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchHolidays();
    },
    componentDidUpdate(prevProps) {
      if (!isEqual(prevProps.dates, this.props.dates)) {
        this.props.fetchHolidays();
      }
    },
  }),
  /*
  mapProps(
    props => ({
      ...props,
      onChangeMonth: (displayMonth) => {
        if (props.onChangeMonth) {
          props.onChangeMonth(displayMonth);
        }
        props.fetchHolidays(displayMonth);
      },
    }),
  ),
  */
  connect(state => ({
    holidays: holidaySelectors.holidays(state),
  })),
  mapProps(({ holidays, ...props }) => ({
    ...props,
    holidayDates: holidays.toList().map(({ date }) => date),
  })),
);
